import queryString from 'query-string';
import fp from 'lodash/fp';
import prependHttp from 'prepend-http';
import {
  branchFuncs
} from './';

const SAFE_EXTERNAL_URL = /^https?:\/\//i;

/**
 * Returns a value safe to place in an href/src attribute, or null.
 *
 * Only absolute http(s) URLs are allowed. This blocks stored XSS payloads such
 * as javascript:, data: and vbscript: that would otherwise execute when a
 * content link is rendered in an iframe or anchor.
 */
export const toSafeExternalUrl = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const candidate = prependHttp(trimmed);
  return SAFE_EXTERNAL_URL.test(candidate) ? candidate : null;
};

export const appendUrlQueryParameters = (parameters) => fp.flow(
  fp.split('?'),
  fp.over([
    fp.head,
    fp.flow(
      fp.tail,
      fp.join(''),
      queryString.parse,
      fp.assign(parameters),
      queryString.stringify
    )
  ]),
  branchFuncs(
    fp.flow(fp.get('[1]'), fp.identity),
    fp.join('?'),
    fp.head
  )
);


// WEBPACK FOOTER //
// ./src/utils/url.js